<template>
  <a-breadcrumb
    v-if="showBreadcrumb"
    class="my-4 mx-0"
    :routes="routes"
  >
    <template
      slot="itemRender"
      slot-scope="{route, _params}"
    >
      <span
        v-if="routes.indexOf(route) === routes.length - 1"
        class="text-lg font-semibold"
      >{{ route.breadcrumbName }}</span>
      <eki-env-link
        v-else
        class="text-base underline"
        :to="route.path"
      >
        {{ route.breadcrumbName }}
      </eki-env-link>
    </template>
  </a-breadcrumb>
</template>

<script lang="ts">
import useBreadcrumb from '@/composables/useBreadcrumb'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'Breadcrumb',

  setup() {
    const { routes, showBreadcrumb } = useBreadcrumb()

    return {
      showBreadcrumb,
      routes
    }
  }
})
</script>